
import Nav from "@/components/Nav.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Previewer from 'vux/src/components/previewer/index.vue'

export default {
name: "schoolDetail",
components: {
Nav,
swiper,
swiperSlide,
Tab,
TabItem,
TransferDom,
Previewer
},
directives: {
TransferDom
},
data() {
return {
detail: {
title: "",
videos: [],
albums: [
{
title: "",
data: [
{
summary: ""
}
]
}
],
info: [],
recommends: [],
cases: []
},
options: [],
keyValue: "",
params: {
keyword: "",
limit: 10,
page: 1,
city_id: "",
grade: "",
fee: ""
},
showDrop: false,

swiperOption: {
loop: false,
autoplay: true,
speed: 3000,
disableOnInteraction: true, //用户操作swiper之后，是否禁止autoplay。
initialSlide: 0,
observer: true, //修改swiper自己或子元素时，自动初始化swiper
observeParents: true, //修改swiper的父元素时，自动初始化swiper




pagination: { el: ".swiper-pagination" }
},
albumIndex: 0,
albumImgIndex: 0,
previewOption: {
loop: false,
autoplay: false,
speed: 3000,
disableOnInteraction: true, //用户操作swiper之后，是否禁止autoplay。
initialSlide: 0,
observer: true, //修改swiper自己或子元素时，自动初始化swiper
observeParents: true, //修改swiper的父元素时，自动初始化swiper
navigation: {
nextEl: ".swiper-button-next",
prevEl: ".swiper-button-prev"
}
},
graduteOption: {
slidesPerView: 3,

loop: false,
autoplay: false,
disableOnInteraction: true, //用户操作swiper之后，是否禁止autoplay。


spaceBetween: 28,
slidesOffsetAfter: 28,
initialSlide: 0,
observer: true, //修改swiper自己或子元素时，自动初始化swiper
observeParents: true, //修改swiper的父元素时，自动初始化swiper




touchMoveStopPropagation: false,
passiveListeners: false,
pagination: { el: ".swiper-pagination" }
},
tabList: ["基本资料", "学校优势", "周边环境", "毕业生去向", "图集"],
tabIndex: 0,
showPreview: false,
previewSummary: "",
list: [],
playing: false,
showPrewImg: false,
images: [],
mode: "album",
startIndex: 0
};
},
computed: {
swiper() {
return this.$refs.mySwiper.swiper;
},
previewSwiper() {
return this.$refs.previewSwiper.swiper;
},
schoolInfo() {
let info = this.detail.info.filter(val => {
return val.content;
});
return info;
}



},
watch: {





},
methods: {
toTop() {
let scrollWrapper = document.getElementsByClassName("scrollWrapper")[0];


scrollWrapper.scrollIntoView({ behavior: "smooth" });
},
logIndexChange(arg) {
console.log(arg);
},
onChange(index) {

},
show(index) {

this.mode = "album";
this.startIndex = index;

this.showPrewImg = true;
},
preview(index, idx) {
this.showPreview = true;
this.albumIndex = index;
this.albumImgIndex = idx;
this.previewSwiper.slideTo(idx, 1000, false);
this.previewSummary = this.detail.albums[index].data[idx].summary;
},
jump(url) {
window.location.href = url;
},
changeTab(index) {
this.tabIndex = index;
if (index == 2) {
this.images = [];
var img = document.getElementsByClassName("wscnph");
let that = this;
console.log(img);
for (var i = 0; i < img.length; i++) {
that.images.push(img[i].src);
}
for (var i = 0; i < img.length; i++) {
img[i].setAttribute("data-index", Number(i));
img[i].addEventListener("click", function(e) {

that.mode = "other";
that.startIndex = Number(e.target.dataset.index);

that.showPrewImg = true;
});
}
}
},
play() {
this.swiper.autoplay.stop();
this.playing = true;
},
end() {
this.swiper.autoplay.start();
this.playing = false;
},
getSchoolDetail(id) {
this.$api.getSchoolDetail(id).then(res => {
if (res.data.success && res.data.code == 0) {
let data = res.data.data;
if (data.albums.length == 0) {
data.albums = [
{
title: "",
data: [
{
summary: ""
}
]
}
];
}
if (data.cases.length > 0) {
data.cases.map(val => {





this.list.push(val.image);
});
}
this.detail = data;
console.log(this.detail, this.list);
} else {
this.$vux.toast.text(res.data.message, "middle");
}
});
}
},
created() {
let id = this.$route.query.id;
console.log(id);
this.getSchoolDetail(id);
},
mounted() {
let that = this;
this.previewSwiper.on("slideChange", function() {
that.albumImgIndex = this.realIndex;
that.previewSummary =
that.detail.albums[that.albumIndex].data[this.realIndex].summary;
});
this.swiper.on("slideChange", function() {
for (var i = 0; i < that.detail.videos.length; i++) {
var myVideo = "myVideo" + i;
var x = document.getElementById(myVideo);
x.pause();
that.playing = false;
}
});
},
activated() {



}
};



// WEBPACK FOOTER //
// ./src/pages/school/schoolDetail.vue